export const TELEMETRY_DOMAINS = {
  ATTENTIVE: 'https://cdn.attn.tv',
  CONSTRUCTORIO: 'https://cnstrc.com',
  CLARITAS: 'https://trkn.us',
  CRITEO_ANALYTICS: 'https://static.criteo.net',
  FB_PIXEL: 'https://connect.facebook.net',
  GOOGLE_TAG_MANAGER: 'https://www.googletagmanager.com',
  IMPACT: 'https://utt.impactcdn.com',
  LINKEDIN_PIXEL: 'https://snap.licdn.com',
  LIVECONNECT: 'https://b-code.liadm.com',
  PEBBLE_POST: 'https://cdn.pbbl.co',
  POPLAR: 'https://d.agkn.com',
  PINTEREST_TAG: 'https://s.pinimg.com',
  RETENTION: 'https://s3-us-west-2.amazonaws.com',
  SNAPCHAT_PIXEL: 'https://sc-static.net',
  STYLIGHT_PIXEL: 'https://cdn.sales.partner.stylight.net',
  TATARI: 'https://d2hrivdxn8ekm8.cloudfront.net',
  TIKTOK_PIXEL: 'https://analytics.tiktok.com',
  EDGE_TAG: 'https://cfscl.quince.com',
}
